import { request } from "../utils/request.js"

export const commoditySpec_findById = (id, args) => request({
    url: 'commoditySpec/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const commoditySpec_findByIdIn = (pojo, args) => request({
    url: 'commoditySpec/findByIdIn',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/commoditySpec.js